import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=f3b097aa&scoped=true&"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=f3b097aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b097aa",
  null
  
)

export default component.exports